import * as React from 'react';
import classNames from 'classnames';
import { SmallImageContext } from '../../../common/ContentfulImage/SmallImageContext.esm.js';
import { NvMarkdownInline, NvSubheading, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './StepperStaticItem.module.esm.js';

var StepperStaticItem = function (_a) {
    var _b = _a.fields, heading = _b.heading, body = _b.body, image = _b.image, bodyAlignment = _b.bodyAlignment, id = _a.id, _c = _a.classes, classes = _c === void 0 ? {} : _c;
    return (React.createElement("li", { className: classNames(styles.root, classes.root, 'animation-fade-up'), "data-testid": id, id: id },
        image && (React.createElement(SmallImageContext, null,
            React.createElement(BaseNucleobaseComponent, { classes: { picture: styles.image }, role: "presentation", source: image }))),
        React.createElement("div", { className: styles.content },
            heading && (React.createElement(NvMarkdownInline, { className: styles.heading, element: "h3", elementWrapper: NvSubheading, level: "level2" }, heading)),
            body && (React.createElement(NvMarkdown, { className: classNames(styles.text, styles[bodyAlignment]), options: { forceWrapper: false } }, body)))));
};

export { StepperStaticItem as default };
//# sourceMappingURL=StepperStaticItem.esm.js.map
